import { action, computed, makeObservable, observable } from "mobx";
import { API } from "../../core";
import { CoreResponse } from "../../response";
import { PromoCode } from "../../interfaces";

export class PromoCodeStore {
	@observable isActive = false;
	@observable discount: number = 0;
	@observable promoCode: string = "";

	constructor() {
		makeObservable(this);
	}

	@action.bound
	async apply(promo_code: string) {
		try {
			const { success, data } = await API.post<CoreResponse<PromoCode>>(`promo-code`, {
				promo_code,
			});

			this.isActive = success;
			this.discount = data.discount_value;
			this.promoCode = promo_code;
		} catch (e) {
			console.error(`Error in method PromoCodeStore.apply : `, e);
		}
	}

	@computed
	get hasDiscount() {
		return this.isActive && this.discount > 0;
	}

	getDiscountPrice(price: number) {
		if (!this.hasDiscount) {
			return price;
		}
		const discountValue = Math.min(Math.max(this.discount, 0), 99);
		return Math.max(0, price * (1 - discountValue / 100));
	}

	@action.bound
	clear() {
		this.isActive = false;
		this.discount = 0;
		this.promoCode = "";
	}
}
